import * as React from "react";
import i18n from "i18n";
import ViewsLogViewWidget from "logview/ViewsLogViewWidget/ViewsLogViewWidget";
import CreateLogViewFromMessageTable from "logview/CreateLogViewFromMessageTable";
import Widget from "views/logic/widgets/Widget";
import validLicensePresent from "license/ValidLicensePresent";
import Icon from "components/common/Icon";
import ExportLogViewWidgetAction from "logview/ExportLogViewWidgetAction";
import LogViewEditComponent from "./components/LogViewEditWidget";
import AddLogViewActionHandler, { CreateLogView } from "./AddLogViewActionHandler";
import LogViewWidget from "./logic/LogViewWidget";
import LogViewHandler from "./LogViewHandler";
import LogViewConfigGenerator from "./LogViewConfigGenerator";
import LogViewExportSettings from "./components/LogViewExportSettings";
Widget.registerSubtype(LogViewWidget.type, LogViewWidget);
const logviewBindings = {
  enterpriseWidgets: [
    {
      type: "LOGS",
      get displayName() {
        return i18n.t("widget_creators.log_view", { ns: "enterprise_search" });
      },
      defaultHeight: 4,
      defaultWidth: 12,
      hasEditSubmitButton: true,
      visualizationComponent: ViewsLogViewWidget,
      editComponent: LogViewEditComponent,
      needsControlledHeight: () => false,
      searchResultTransformer: (data) => data[0],
      searchTypes: LogViewConfigGenerator,
      titleGenerator: () => "Log View",
      exportComponent: LogViewExportSettings
    }
  ],
  widgetCreators: [
    {
      title: "Log View",
      titleKey: "enterprise_search:widget_creators.log_view",
      func: CreateLogView,
      icon: () => /* @__PURE__ */ React.createElement(Icon, { name: "view_list" })
    }
  ],
  creators: [
    {
      type: "preset",
      title: "Log View",
      titleKey: "enterprise_search:widget_creators.log_view",
      func: AddLogViewActionHandler,
      useCondition: validLicensePresent
    }
  ],
  searchTypes: [
    {
      type: LogViewWidget.type,
      handler: LogViewHandler,
      defaults: {}
    }
  ],
  "views.widgets.actions": [CreateLogViewFromMessageTable, ExportLogViewWidgetAction]
};
export default logviewBindings;
